export const PROFESSIONAL_PROFILES = [
  'AuxiliarEnfermagem',
  'Cuidador',
  'Enfermeiro',
  'Medico',
  'TecnicoEnfermagem',
  'Outro'
];

export const EDITABLE_PROFILES = [
  'AuxiliarEnfermagem',
  'Cuidador',
  'Enfermeiro',
  'Familiar',
  'Medico',
  'Residente',
  'TecnicoEnfermagem',
  'Outro'
];
